import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.464 4.464a5 5 0 0 1 7.243 6.891l-.167.175L13.12 24.122a3 3 0 0 1-4.382-4.094l.134-.143L19.287 9.298a1 1 0 0 1 1.508 1.308l-.083.095-10.419 10.592a1 1 0 0 0 1.316 1.501l.093-.082 12.419-12.591a3 3 0 0 0-4.093-4.383l-.145.135L7.465 18.465a5 5 0 0 0 6.89 7.243l.181-.173 10.257-10.243a1 1 0 0 1 1.496 1.321l-.083.094L15.95 26.95a7 7 0 0 1-9.9 0 7 7 0 0 1-.186-9.706l.181-.189z"
    />
  </svg>
);
const SvgIconPaperclip = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPaperclip);
export default Memo;
